<template>
	<v-btn-toggle
		:color="color"
		:value="selected"
		@change="onChange($event)"
		:group="group"
		:borderless="borderless"
		:multiple="multiple"
		:tile="tile"
		:mandatory="mandatory"
	>
		<slot></slot>
	</v-btn-toggle>
</template>

<script>
export default {
	props: {
		color: String,
		value: [String, Array, Boolean, Number],
		borderless: Boolean,
		multiple: Boolean,
		group: Boolean,
		tile: Boolean,
		mandatory: Boolean,
	},
	computed: {
		selected() {
			return this.value
		},
	},
	methods: {
		onChange(event) {
			if (typeof event === 'undefined') { return }
			this.$emit('change', event)
			this.$emit('input', event)
		},
	},
}
</script>
